import React from 'react'
//import shareVideo from '../public/assets/share.mp4';
import { useRouter } from 'next/router'

import LoginForm from './auth/LoginForm';

import {useStateContext} from '../context/StateContext';
import { AuthContext } from '../context/AuthContext';
import axios from "axios"

const Login = () => {
    
const router = useRouter()
//const hostName = window?.location?.origin
const hostName = "testDomain"
const navigateToAuth = ()  => {
    router.push('/api/auth/callback')      
    }
const { apiUrl } = useStateContext() 
//console.log("dwklpqwodk", apiUrl)


//console.log("API URL", apiUrl)   
  return (
        <div style={{width:"100%", height:"100vh"}}>
            <div style={{position:"absolute", top:0, left:0, width:"100%", height:"100%", backgroundColor:"rgba(0,0,0,0.7)"}}></div>
            <video
                src={"/assets/share.mp4"}
                type="video/mp4"
                loop="loop"
                controls={false}
                muted={true}
                autoPlay="autoPlay"
                playsInline
                style={{width:"100%", height: "100%", objectFit:"cover"}}
            />
                <div style={{position:"absolute", width:"100%", height: "100%", top:0, display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", color:"white"}}>
                <img src="/assets/logowhite.png" alt="logoWhite" style={{width:"70px", height:"50", marginBottom:"15px"}} />
{/*                     <a href='/api/auth/login' className="login-button">
                        LOG IN
                    </a> */}
                    <LoginForm
                        buttonClassName="login-button" 
                        transparentBackground = {true}
                        labels={{email: "EMAIL", password:"PASSWORD", color: "white"}} 
                        AuthContext={AuthContext}
                        hideTitle = {true}
                        otpEnabled = {true}
                        disableSignup = {true}
                        database={"sanity"}
                        queryUrl = {`${apiUrl}/users/login`}
                        emailUserExistsQueryUrl = {`${apiUrl}/user-email-exists`}
                    />
                </div>
        </div>
  )
}

export default Login

/*


import React from 'react'
import shareVideo from '../assets/share.mp4';

const Login = () => {
  return (
    <div>
    <div>
        <video
            src={shareVideo}
            type="video/mp4"
            loop="loop"
            controls={false}
            muted="muted"
            autoPlay="autoPlay"
        />
    <div/>
      <a href='/api/auth/login'>loggin</a>
    </div>
  )
}

export default Login





import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {GoogleLogin, googleLogout} from '@react-oauth/google';
import shareVideo from '../assets/share.mp4';
import logo from '../assets/logowhite.png';
import jwt_decode from 'jwt-decode'
import {emailQuery} from '../lib/data';
import {client} from '../client';

const Login = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState();
    const [googleEmail, setGoogleEmail] = useState(undefined);
    const [googleSub, setGoogleSub] = useState(undefined);
    const [googlePicture, setGooglePicture] = useState(undefined);

    const [errorEmail, setErrorEmail] = useState(undefined);

    const logout = () => {

        googleLogout()
        localStorage.clear();

        navigate('/login');
    };

    const responseGoogle = (response) => {
        const decode = jwt_decode(response.credential);
        //console.log("DECODED: ",decode)
        //localStorage.setItem('user', JSON.stringify(decode));

        const {name, sub, picture, email} = decode;

        console.log("Google email: ", email)
        setGoogleEmail(email)
        setGoogleSub(sub)
        setGooglePicture(picture)
        console.log("email google state: ", googleEmail)

    };

    useEffect(() => {
        console.log("user effect triggered")
        if (googleEmail) {
            const query = emailQuery(googleEmail);
            console.log("query triggered")
            client
                .fetch(query)
                .then((data) => {
                    console.log("data: ", data)
                    if (data.length == 0) {
                        console.log("email non trovata")
                        setErrorEmail(
                            "The email address is not in the system, contact management or support"
                        )
                        logout()
                    } else {

                        setUser(data[0]);

                    }

                })

        }

    }, [googleEmail]);

    useEffect(() => {
   
        if (
            user
                ?.email
        ) {
            client.patch(user._id).setIfMissing({sub: googleSub, image:googlePicture }).commit().then(() => {
                localStorage.setItem('user', JSON.stringify({...user,sub: googleSub, image:googlePicture}));
                navigate('/', {replace: true});
              })
              .catch((err) => {
                console.error('Oh no, the update failed: ', err.message)
              })
        } 

    }, [
        user
            ?.email
    ]);

    return (
        <div className="flex justify-start items-center flex-col h-screen">
            <div className=" relative w-full h-full">
                <video
                    src={shareVideo}
                    type="video/mp4"
                    loop="loop"
                    controls={false}
                    muted="muted"
                    autoPlay="autoPlay"
                    className="w-full h-full object-cover"/>

                <div
                    className="absolute flex flex-col justify-center items-center top-0 right-0 left-0 bottom-0 bg-blackOverlay">
                    <div className="p-5">
                        <img src={logo} width="180px" alt="logo"/>
                    </div>

                    <div className="shadow-2xl">
                        <GoogleLogin
                            onSuccess={responseGoogle}
                            onError={() => console.log('Login Failed')}/>
                    </div>
                    <h1 className="text-white text-center m-4 text-xl font-bold break-words mt-3">
                        {errorEmail}
                    </h1>
                </div>
            </div>
        </div>
    );
};

export default Login;

*/